// "A newer version is ready" — the one notice that tells a user their tab is
// on a stale build (utils/buildFreshness.js) and reloads it for them. Also
// what NoVA reads: the outline carries it as a status line and a
// data-nova-note, so "this looks broken" gets "reload first".
import React, { useEffect, useState } from 'react';
import { getBuildFreshness, subscribeBuildFreshness, startBuildFreshnessWatch, reloadToLatest } from '../utils/buildFreshness';

export default function BuildFreshness({ name = 'nventr' }) {
  const [fresh, setFresh] = useState(getBuildFreshness());
  const [dismissed, setDismissed] = useState('');
  useEffect(() => {
    const unsub = subscribeBuildFreshness((s) => setFresh({ ...s }));
    const stop = startBuildFreshnessWatch();
    return () => { unsub(); stop(); };
  }, []);
  if (!fresh.stale || dismissed === fresh.live) return null;
  return (
    <div className="nv-stale" role="status" aria-live="polite" data-nova-note="The app is out of date: a newer build is live. Reloading the page (the Reload button in this notice) fixes it.">
      <span>A newer version of {name} is ready.</span>
      <button type="button" className="cs-btn cs-btn-sm cs-btn-primary" onClick={reloadToLatest}>Reload</button>
      <button type="button" className="nv-stale-x" aria-label="Dismiss" onClick={() => setDismissed(fresh.live)}>×</button>
    </div>
  );
}
